import { useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../utils/toastMessage/toastMessage";
import { createNotificationsService } from "../../services/publicServices";
import CustomModal from "../CustomModal/CustomModal";

const CreateNotification = () => {
  const dispatch = useDispatch();

  const [fullName, setFullName] = useState("");
  const [tableNumber, setTableNumber] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);

  const handleShowModal = () => {
    setIsShowModal(true);
  };
  const handleHideModal = () => {
    setIsShowModal(false);
    setFullName("");
    setTableNumber("");
  };

  // Create Notification
  const handleCreateNotification = async (event) => {
    event?.preventDefault();

    const objData = { fullName, tableNumber };

    if (!fullName) return toastErrorMessage("نام کامل الزامی است");
    if (!tableNumber) return toastErrorMessage("شماره میز الزامی است");

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createNotificationsService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleHideModal();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <div
        onClick={handleShowModal}
        className="rounded-circle text-dark p-2 position-fixed"
        style={{
          cursor: "pointer",
          bottom: 30,
          left: 30,
          zIndex: 100,
          backgroundColor: "#b99272",
        }}
      >
        <div className="icon">
          <i className="las la-bell display-3" />
        </div>
      </div>

      <CustomModal
        size="md"
        title="درخواست سفارش"
        show={isShowModal}
        onHide={handleHideModal}
      >
        <form onSubmit={handleCreateNotification}>
          <div className="row">
            <div className="col-12">
              <div className="kf-field">
                <input
                  type="text"
                  name="fullName"
                  placeholder="نام کامل"
                  onChange={(e) => setFullName(e.target.value)}
                  value={fullName}
                />
                <i className="la la-user" />
              </div>
            </div>
            <div className="col-12">
              <div className="kf-field">
                <input
                  type="text"
                  name="tableNumber"
                  placeholder="شماره میز"
                  onChange={(e) => setTableNumber(e.target.value)}
                  value={tableNumber}
                />
                <i className="la la-table" />
              </div>
            </div>
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>ارسال</span>
            </button>

            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={handleHideModal}
            >
              انصراف
            </button>
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default CreateNotification;
